import { PencilIcon } from '@heroicons/react/24/outline';
import { format, set } from 'date-fns';
import { useIntl } from 'react-intl';

import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import LoadingContainer from 'src/componentes/loading-container';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import formatDateFns from 'src/utils/formatDateFns';
import Pagination from 'src/componentes/list/pagination';
import { useState } from 'react';

const SecaoFormacoesAcademicas = ({ colaborador, isLoading, ...rest }) => {
  const intl = useIntl();
  const { user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const renderData = (item) => {
    if (!item.dataConclusao) return;

    return format(item.dataConclusao, currentDisplay, {
      locale: currentLocale,
    });
  };

  const renderNome = (item) => (
    <span>{item.nivelEducacional && item.nivelEducacional.nome}</span>
  );

  const count = colaborador?.formacoesAcademicas?.length || 0;

  const currentData = colaborador?.formacoesAcademicas?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="border rounded-lg p-4 mb-4 shadow">
      <LoadingContainer isLoading={isLoading}>
        <div className="d-flex text-primary">
          <PencilIcon
            style={{ width: '20px', marginBottom: '12px' }}
            className="mr-2"
          />
          <div className="text-primary text-base font-weight-bold mb-2 text-xl">
            {capitalizeFirstLetter(
              intl.formatMessage({ id: 'formacoesAcademicas' })
            )}
          </div>
        </div>
        {!isLoading && (
          <List
            local
            showTitle={false}
            dataSource={currentData}
            showPage={false}
            showSearch={false}
            showNew={false}
            showMenu={false}
            showExport={false}
            styleCard={{ border: 'none', boxShadow: 'none', marginBottom: 0 }}
            styleCardBody={{ padding: 0 }}
            pageSize={5}
            {...rest}
          >
            <ListColumn
              headerText={intl.formatMessage({ id: 'nivelEducacional' })}
              valueFunction={renderNome}
            ></ListColumn>
            <ListColumn
              headerText={intl.formatMessage({ id: 'curso' })}
              valueField="curso"
            ></ListColumn>
            <ListColumn
              headerText={intl.formatMessage({ id: 'instituicaoEnsino' })}
              valueField="instituicaoEnsino"
            ></ListColumn>
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataConclusao' })}
              valueFunction={renderData}
            ></ListColumn>
          </List>
        )}
        <div className="d-flex w-100 justify-content-end">
          <Pagination
            allowPaging={true}
            currentPage={currentPage}
            count={count}
            pageSize={pageSize}
            showPaginacaoSimples={false}
            changeCurrentPage={(page) => setCurrentPage(page)}
            changePageSize={(size) => setPageSize(size)}
            noLimitPageSize={true}
          />
        </div>
      </LoadingContainer>
    </div>
  );
};

export default SecaoFormacoesAcademicas;
